import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/luckycards/card-box-bg-3.png';
import _imports_1 from '@assets/images/luckycards/cards-box.png';
import _imports_2 from '@assets/images/luckycards/opacity-gif.png';
const _withScopeId = n => (_pushScopeId("data-v-1ba60068"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "card-box"
};
const _hoisted_2 = {
  key: 0,
  class: "card-box-bg-1"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-box-bg-3"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_5 = {
  class: "top-box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/image/card_bg_small.png",
  alt: "",
  class: "paggif"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top_bg"
}, null, -1));
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  key: 0,
  class: "cards-box-gif",
  src: _imports_1
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "opacity-gif",
  src: _imports_2
}, null, -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  class: "icon-box"
};
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = {
  ref: "editorBox"
};
const _hoisted_15 = {
  class: "btns-box"
};
const _hoisted_16 = {
  class: "subscribe-btn"
};
const _hoisted_17 = {
  class: "subscribe-time"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0,
  class: "btn_must"
};
const _hoisted_20 = {
  key: 1,
  class: "btns btn_1 btn_1_end"
};
const _hoisted_21 = {
  class: "fixed-btn"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/luckycards/group/card_detail_group_btn.png"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "组团", -1));
const _hoisted_24 = {
  class: "num"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/luckycards/share_btn.png"
}, null, -1));
const _hoisted_26 = [_hoisted_25];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_CompRules = _resolveComponent("CompRules");
  const _component_CompOrder = _resolveComponent("CompOrder");
  const _component_CompEWM = _resolveComponent("CompEWM");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [$data.cards_info.detail_image_url ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: `${$data.cards_info.detail_image_url}?x-oss-process=image/blur,r_15,s_10/resize,w_620,m_lfit/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1`,
    alt: ""
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "card-box-bg-2",
    style: _normalizeStyle(`background-color: #${$data.color};`)
  }, null, 4), _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($data.cards_info.name), 1), _createElementVNode("div", {
    class: _normalizeClass(['cards-box', {
      small: $data.small,
      huanhe: $data.huanhe
    }])
  }, [$data.gif ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "cards-img",
    style: _normalizeStyle(`background-image: url('${_ctx.$imgUrlFilter($data.cards_info.detail_image_url || '', 620)}')`)
  }, _hoisted_11, 4)], 2), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "icon icon-user-collect",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goUserCollect && $options.goUserCollect(...args))
  }), _createElementVNode("view", {
    class: "icon icon-container",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goContainer && $options.goContainer(...args))
  })])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, null, 512)]), _createElementVNode("view", {
    class: "icon-change",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.huanheFn && $options.huanheFn(...args))
  }), _createElementVNode("div", {
    class: "rules",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.showRules && $options.showRules(...args))
  }, "抽卡规则"), _createElementVNode("div", _hoisted_15, [($data.cards_info.status_code == 1 || $data.cards_info.status_code == 2) && $data.buttons.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.cards_info.status_code == 2 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.buttons, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "btns btn_1 btn_subscribe",
      onClick: _cache[4] || (_cache[4] = $event => $options.subscribeActivity())
    }, [_createElementVNode("div", _hoisted_16, _toDisplayString($data.cards_info.have_subscribe ? '已预约' : '立即预约'), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(item.button_name), 1)]);
  }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.buttons, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['btns', `btn_${$data.buttons.length}_${index}_${item.type_code}`, `btn_${$data.buttons.length}_${item.type_code}`, `btn_${$data.buttons.length}`]),
      onClick: $event => $options.showOrder(item)
    }, [_createTextVNode(_toDisplayString(item.button_name && item.button_name.slice(0, 6)) + " ", 1), item.must_card_level_name ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.must_card_level_name), 1)) : _createCommentVNode("", true)], 10, _hoisted_18);
  }), 128))], 64)) : !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_20, "售罄，补货中")) : _createCommentVNode("", true)]), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "back",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goBack && $options.goBack(...args))
  })) : _createCommentVNode("", true), _createVNode(_component_CompRules, {
    show_rules: $data.show_rules,
    "onUpdate:show_rules": _cache[6] || (_cache[6] = $event => $data.show_rules = $event),
    rules_arr: $data.rules_arr
  }, null, 8, ["show_rules", "rules_arr"]), _createVNode(_component_CompOrder, {
    ref: "CompOrder",
    show_order: $data.show_order,
    "onUpdate:show_order": _cache[7] || (_cache[7] = $event => $data.show_order = $event),
    cards_id: $data.cards_id,
    cards_info: $data.cards_info,
    item: $data.order_item,
    name: $data.cards_info.name,
    pay_amount: $data.pay_amount,
    order_id: $data.order_id,
    addressItem: $data.addressItem,
    probabilityList: $data.probabilityList,
    onChangeAddress: $options.changeAddress,
    onPayDown: $options.payDown
  }, null, 8, ["show_order", "cards_id", "cards_info", "item", "name", "pay_amount", "order_id", "addressItem", "probabilityList", "onChangeAddress", "onPayDown"]), _createElementVNode("div", _hoisted_21, [$data.cards_info.group_info && $data.cards_info.group_info.id ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-btn share-btn-group",
    onClick: _cache[8] || (_cache[8] = $event => $options.goGroupInfo($data.cards_info.group_info.id))
  }, [_hoisted_22, _hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString($data.cards_info.group_info.user_num) + "人已参团", 1)])) : _createCommentVNode("", true), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "share-btn",
    onClick: _cache[9] || (_cache[9] = (...args) => $options.onShare && $options.onShare(...args))
  }, _hoisted_26)) : _createCommentVNode("", true)]), _createVNode(_component_CompEWM, {
    show: $data.showEWM,
    "onUpdate:show": _cache[10] || (_cache[10] = $event => $data.showEWM = $event)
  }, null, 8, ["show"])]));
}